module.exports = __webpack_public_path__ + "img/fodbosa.daae8100.png";